import { render, staticRenderFns } from "./FlowData.vue?vue&type=template&id=7645b4e6&scoped=true"
import script from "./FlowData.vue?vue&type=script&lang=js"
export * from "./FlowData.vue?vue&type=script&lang=js"
import style0 from "./FlowData.vue?vue&type=style&index=0&id=7645b4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7645b4e6",
  null
  
)

export default component.exports